import React, { useEffect } from 'react';
import L from 'leaflet';
import { Marker, withLeaflet } from 'react-leaflet';
import PropTypes from 'prop-types';
import locationIconImage from 'images/icons/white-marker-icon.png';
import { useElevation } from './ElevationProvider';

function ElevationLocation(props) {
  const { leaflet } = props;
  const { setMap, location } = useElevation();

  const locationIcon = L.icon({
    iconUrl: locationIconImage,
    iconSize: [18, 30],
    iconAnchor: [9, 30],
  });

  useEffect(
    () => {
      setMap(leaflet.map);
    },
    [leaflet.map],
  );

  return location ? <Marker position={location} icon={locationIcon} /> : null;
}

ElevationLocation.propTypes = {
  leaflet: PropTypes.object.isRequired,
};

export default withLeaflet(ElevationLocation);
